// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"633":"bdd49b1f379e78be","825":"e46b147d890b9162"}[chunkId] + ".js";
};